<template>
    <div class="authsucc">
        <div class="header">
            <img src="../../../assets/images/account/auth_fail.png"/>
            <div><span>实名认证失败! 请重新尝试</span></div>
        </div>

        <div class="footer">
            <van-button @click="back()" type="info">
                重新识别
            </van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'authfail',
    computed: {
		idcardBefore() {
			return this.$store.state.idcardBefore
		},
	},
    methods: {
        back() {
            if(this.idcardBefore?.includes('/modifyPhone')){ // 通过实名认证修改手机号
                this.$router.replace('/scan')
                return
            }
            this.$router.back();
        }
    }
}
</script>
<style scoped>
    .authsucc {
        display: flex;
        font-size: 1rem;
        flex-direction: column;
        align-items: center;
        height: 100vh;
    }

    .authsucc .header {
        margin-top: 100px;
        text-align: center;
    }

    .authsucc .header img {
          width: 340px;
          height: 340px;
    }

    .authsucc .footer {
        margin-top: 100px;
    }
    .van-button {
        width: 250px;
        font-size: 18px;
        border-radius: 50px;
    }

</style>